

(function representativeExemple () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "representative-exemple";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    $(() => {
      const toggles = document.querySelectorAll('.toggle-switch input[type="checkbox"]');

      const updateAriaChecked = (event) => {
        const checkbox = event.target;
        checkbox.setAttribute('aria-checked', checkbox.checked.toString());
      }

      toggles.forEach(toggle => {
        toggle.addEventListener('change', updateAriaChecked);
        updateAriaChecked({ target: toggle });
      });
    })

    })()